
import logo from './londonlatin-logo.png';
import homePic1 from './LandingPageImage.png';
import homePic2 from './LandingPageFooterWide.png';
import './App.css';
import React, { useState, useEffect } from 'react';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { supabase } from './supabaseClient'

//----------------------------------- Start of new code -----------------------------------



//----------------------------------- End of new code -----------------------------------

export default function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(false); // Track if user is authenticated
  const [activeTab, setActiveTab] = useState("home");
  const [appUrlParam, setAppUrlParam] = useState(null);
  const isMobile = window.innerWidth <= 800;
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  //----------------------------------- SECTION 1 - CODE TO HANDLE TAB CHANGES -----------------------------------
  const handleChange = (event) => {
    const clickedTab = event.target.id;
    console.log("Tab clicked: ", clickedTab);
    setActiveTab(clickedTab);
  };

  //----------------------------------- SECTION 2 - CODE TO HANDLE EXPLORE DATA APP -----------------------------------

  function handleSearch(event) {
    const filter = event.target.value.toUpperCase();
    const div = document.getElementById("myDropdown");
    const a = div.getElementsByTagName("a");
    
    for (let i = 0; i < a.length; i++) {
      const txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";
      } else {
        a[i].style.display = "none";
      }
    }

    // Toggle the dropdown if the input is not empty
    if (filter) {
      div.classList.add("show");
    } else {
      div.classList.remove("show");
    }
  }

  // function to change explore data app url with new id param
  function loadPublicIframe(id) {
    if (!id || id === "null") {
        console.warn("No explore iframe id found.... not updating iframe.");
        return;
    }
    console.log('Loading explore iframe with ID:', id);
    const url = `https://connect.latindancehub.co.uk/?highlight_user=${id}`;
    document.getElementById('content-frame2').src = url;
  }

  // function to change shell id url param to match explore data id url param
  function updateShellUrl () {
    console.log("Updating shell url...");
    const url = new URL(window.location);
    url.searchParams.set('highlight_user', appUrlParam);
    window.history.pushState({}, '', url);
  };

  /*useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== "https://dev.d2eavm9rnknaoc.amplifyapp.com") return;

      if (event.data?.type === "SET_ACTIVE_TAB") {
        console.log("Setting tab to manage");
        setActiveTab("manage");
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);*/

  // If explore data app url is updated with a different id param then this use effect will update the shell url to display the same url id param
  useEffect(() => {
    if (activeTab === "explore" && appUrlParam !== "null" && appUrlParam) {
        console.log("App url parameter change detected...");
        console.log("Updating shell url...");
        updateShellUrl();
    }
  }, [appUrlParam]);
  
  // Use effect to run on load - checks whether  user has id param in shell url and, if true, loads explore data app with same id url param.
  useEffect(() => {
    
    console.log("Checking for iframe id...");
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("highlight_user");
    const activeTabParam = urlParams.get("activeTab");

    console.log("id: ", id);
    if (id && id !== "null") {
      if (activeTab !== "explore") {
        console.log("Setting active tab to explore...");
        setActiveTab("explore");
      }
      console.log('URL params found.  Checking against url parameter state...');
      console.log("Current app url parameter state is: ", {appUrlParam});
      console.log("New url param is: ", id);
      if (id !== appUrlParam) {
        setAppUrlParam(`${id}`);
        loadPublicIframe(id);
      } else {
        console.log("id already matches appUrlParam");
      }
      
    } else {
      console.log("No iframe id found.");
    }

    if (activeTabParam) {
      console.log("Setting active tab from URL:", activeTabParam);
      setActiveTab(activeTabParam);
    }

  }, []);

    
  
  
  //----------------------------------- SECTION 3 - CODE TO HANDLE USER AUTHENTICATION -----------------------------------
  function handleLogin() {
    console.log("Login button clicked!");

    const oauthURL = `https://www.arcgis.com/sharing/rest/oauth2/authorize?client_id=hOLu9owaa80vNN22&response_type=code&redirect_uri=${window.location.origin}`;
    
    // Redirect to ArcGIS OAuth page
    window.location.href = oauthURL;
  }

  // This will run when the user is redirected back to /oauth-redirect
  const handleOAuthRedirect = async () => {
    console.log("Handling OAuth redirect...");

    const urlParams = new URLSearchParams(window.location.search);
    const authCode = urlParams.get('code');
    console.log(authCode);
    if (!authCode) {
        console.error("No authorization code found in URL.");
        return;
    }

    try {
        console.log(window.location.origin)
        const response = await fetch("https://ap1unnpuu2.execute-api.eu-west-2.amazonaws.com/dev/nrnhub_oauth", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                code: authCode,
                redirect_uri: window.location.origin
            })
        });

        const data = await response.json();
        
        if (response.ok) {
            console.log("Tokens received from Lambda:", data);

            // Store tokens in localStorage
            localStorage.setItem('accessToken', data.access_token);
            if (data.refresh_token) {
                localStorage.setItem('refreshToken', data.refresh_token);
            }
            localStorage.setItem('expiresIn', data.expires_in);
            localStorage.setItem('tokenTimestamp', Date.now());

            // Fetch user info using the access token
            const userResponse = await fetch('https://www.arcgis.com/sharing/rest/community/self?f=json', {
              method: 'GET',
              headers: {
                  'Authorization': `Bearer ${data.access_token}`
              }
            });

            console.log("User response: ", userResponse)

            const userData = await userResponse.json();
            console.log("User data: ", userData);

            // Store username in local storage and setUser as username
            if (userData.username) {
                //setUser({ username: userData.username }); // Set actual username in the state
                localStorage.setItem('username', userData.username);
            }

            // Clear URL parameters
            window.history.replaceState({}, document.title, window.location.pathname);

            // Set authentication state
            setIsAuthenticated(true);
            setActiveTab("manage")
        } else {
            console.error("Failed to exchange authorization code:", data);
        }
    } catch (error) {
        console.error("Error during token exchange:", error);
    }
  };

  //function exchangeAuthCodeForToken(authCode) {
    //console.log("Exchanging Auth Code For Token");
    //console.log(authCode);
    //return new Promise((resolve, reject) => {
        //const apiUrl = 'https://ap1unnpuu2.execute-api.eu-west-2.amazonaws.com/dev/nrnhub_oauth'; // NRN Hub OAuth lambda function Gateway URL

        // Prepare the request payload
        //const payload = {
            //code: authCode,
            //redirect_uri: window.location.origin
            //redirect_uri: "http://localhost:3002"
        //};

        // Send a POST request to your Lambda function via API Gateway
        //fetch(apiUrl, {
            //method: 'POST',
            //headers: {
                //'Content-Type': 'application/json'
            //},
            //body: JSON.stringify(payload)
        //})
            //.then(response => response.json())
            //.then(data => {
                //if (data.access_token) {
                    //resolve(data);  // Return the tokens if successful
                //} else {
                    //reject(new Error("Failed to retrieve tokens: " + JSON.stringify(data)));
                //}
            //})
            //.catch(error => reject(error));
    //});
  //}

  // this use effect runs once on mount 
  useEffect(() => {
    console.log("Checking for stored tokens or authorization code and userinfo...");

    // Check if the current URL contains the OAuth2 authorization code
    const urlParams = new URLSearchParams(window.location.search);
    const authCode = urlParams.get('code');

    if (authCode) {
        console.log("Authorization code found in URL, processing redirect...");
        handleOAuthRedirect();
    } else {
        // Check if tokens are already saved in localStorage
        const accessToken = localStorage.getItem('accessToken');
        const refreshToken = localStorage.getItem('refreshToken');
        const username = localStorage.getItem('username');

        if (accessToken && username) {
            console.log("Access token & username found, user is authenticated.");
            console.log("Token code: ", accessToken);
            console.log("User is: ", username);
            setIsAuthenticated(true);
        } else if (accessToken){
            console.log("Access token found, but not username. User needs to log back in....")
            setIsAuthenticated(false);
        } else if (refreshToken) {
            console.log("Attempting to refresh token...");
            refreshToken();  
        } else {
            console.log("No valid tokens found. User is not authenticated.");
        }
    }
  }, []);

  
  //----------------------------------- SECTION 4 - CODE TO HANDLE ADD / EDIT DATA APPS -----------------------------------
  
  function loadIframeWithFilter(option) {
    console.log("loading edit / add data Iframe....")

    const username = localStorage.getItem('username');
    console.log("user is: ", username)

    if (option === "addProject"){
      const url = `https://survey123.arcgis.com/share/9c1232b6dde844e48d8a2f349a336cf4?field:data_owner=${username}`;
      console.log("url is: ", url)
      document.getElementById('content-frame2').src = url;
    }

    if (option === "addIntervention"){
      const url = `https://survey123.arcgis.com/share/67e557fffef245db8a4863ba78067378?field:data_owner=${username}`;
      console.log("url is: ", url)
      document.getElementById('content-frame2').src = url;
    }

    if (option === "edit"){
      const url = `https://experience.arcgis.com/experience/348918d71ea74a0d9f9030fea53dd25e?data_filter=dataSource_18-87da678336454eeb954bc3e4f98b1e01:data_owner%3D%27${username}%27,dataSource_19-193abe33644-layer-27:data_owner%3D%27${username}%27`;
      console.log("url is: ", url)
      document.getElementById('content-frame2').src = url;
    }
  }
  
  useEffect(() => {
    if (isAuthenticated && activeTab === "manage") {
        console.log("Checking activeTab:", activeTab, "and isAuthenticated:", isAuthenticated);
        console.log("Loading filtered iframe after authentication...");
        loadIframeWithFilter('addProject');
        //setAddEditOption('add');
    }
  }, [isAuthenticated, activeTab]);

  //----------------------------------- SECTION 5 - handle Update Password-----------------------------------

  const handleUpdatePassword = async () => {
    setError("");
    setSuccess("");

    if (!password) {
      setError("Please enter a new password.");
      return;
    }

    if (password.length < 8) {
      setError("Your password must be at least 8 characters long.");
      return;
    }

    if (password !== confirmPassword) {
      setError("The passwords do not match.");
      return;
    }

    const { error } = await supabase.auth.updateUser({
      password,
    });

    if (error) {
      console.error("Password update error:", error);

      setError(
        "Unable to update your password. Your reset link may have expired. Please request a new password reset email."
      );

      return;
    }

    setSuccess("Your password has been updated successfully.");

    setTimeout(() => {
      setActiveTab("manage");
    }, 2000);
  };
  
  //----------------------------------- End of New Code-----------------------------------

  return (
    <div className="App">

      <div className="prototype-banner">
      Prototype Hub Under Development
      <span>
      Latin Dance Hub is currently being built. Listings are for testing and feedback.
      </span>
      </div>

      <nav className="navbar navbar-default navbar-static-top first-tier">
        <div className="container">
          <ul className="nav nav-pills pull-right" role="navigation">
          </ul>
          <div className="navbar-brand">
            <div id="logo" className="site-logo text-center">
              <img className="logo" src={logo} alt=""/>
              <h1 className="nav-title" id="title">
                Latin Dance Hub
              </h1>
            </div>
          </div>
        </div>
      </nav>

      <nav>
      <div className="topnavMenu">
        <button
          id="home"
          onClick={handleChange}
          className={`toggle-button ${activeTab === "home" ? "toggle-button-active" : ""}`}>
          Home
        </button>
        <button
          id="explore"
          onClick={handleChange}
          className={`toggle-button ${activeTab === "explore" ? "toggle-button-active" : ""}`}>
          Connect
        </button>
        <button
          id="manage"
          onClick={handleChange}
          className={`toggle-button ${activeTab === "manage" ? "toggle-button-active" : ""}`}>
          Your Profile
        </button>
      </div>
      </nav>

      <div className="ContentContainer">
        <div className={`pictureDiv ${activeTab === "home" ? "" : "hidden"}`}>
          <img className="homePic1" src={homePic1} alt=""/>
        </div>

        <div className={`welcomeTextDiv ${activeTab === "home" ? "" : "hidden"}`}>
        
        <h1 className="hero-title">
          Find your flow with
          <span className="hero-title-bold">Latin Dance Hub</span>
        </h1>

          <p>Dancers. Dreamers. Rhythm-chasers. Welcome home.  </p>
          <p>Whether you're a seasoned salsero or taking your first bachata steps, Latin Dance Hub connects you to the heartbeat of the city’s vibrant dance scene. Discover a network of dancers, classes, social nights, studios, festivals, and local instructors - all in one place.</p>
          <ul>
            <li>Looking for a place to dance tonight?</li>
            <li>Need a new partner to practice with?</li>
            <li>Want to book a private lesson?</li>
          </ul>
          <p>We've got you covered.</p>
          <p>This is more than a dance directory - it's a community.</p>
        </div>
      

        <div className={`contentDiv2 ${activeTab === "explore" ? "" : "hidden"}`}>
          <iframe 
            title="exploreApp"
            id="content-frame2" 
            src="https://connect.latindancehub.co.uk/"
            style={{width:"100%", height: isMobile ? "110vh" : "100vh"}}   
            frameBorder="0">
          </iframe>
        </div>

        <div className={`contentDiv2 ${activeTab === "manage" ? "" : "hidden"}`}>
          <iframe 
            title="manageApp"
            id="content-frame2" 
            src="https://dev.d3tkfspkrlvay2.amplifyapp.com/"
            style={{width:"100%", minHeight: "55vh", maxHeight:"100vh"}}   
            frameBorder="0">
          </iframe>
        </div>

        <div className={`resetPasswordDiv ${activeTab === "update-password" ? "" : "hidden"}`}>

          <h1 className="hero-title-bold-small">Reset Your Password</h1>

          <div className="password-reset-form">

            <div className="password-reset-form-item" >
              <input
                className="password-reset-input"
                type={showPassword ? "text" : "password"}
                placeholder="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            <div className="password-reset-form-item">
              <input 
                className="password-reset-input"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            <button
              className="password-reset-submit"
              onClick={handleUpdatePassword}
            >
              Update Password
            </button>

            {error && (
              <p className="error-message">
                {error}
              </p>
            )}

            {success && (
              <p className="success-message">
                {success}
              </p>
            )}

          </div>

        </div>

        <p className="explore-learn-connect-move-banner">
          <span className="tilde1"> ~ </span> Explore
          <span className="tilde2"> ~ </span> Learn 
          <span className="tilde3"> ~ </span> Connect
          <span className="tilde4"> ~ </span> Move
          <span className="tilde5"> ~ </span>
        </p>
        
        <div className="footerDiv">
          <img className="homePic1" src={homePic2} alt=""/>
        </div>

      </div>

    </div>
  );
}

